export default __webpack_public_path__ + "static/media/InChulPark.f05704b0.png";